import { useRouter, type ErrorComponentProps } from '@tanstack/react-router';
import { Button, GivmoWordmark, testIdProp } from '@givmo/design-system';

export function AppError({ reset }: ErrorComponentProps) {
  const router = useRouter();

  return (
    <main
      className="mx-auto flex min-h-screen max-w-[32rem] flex-col items-center justify-center gap-16 px-16 text-center"
      {...testIdProp('page-app-error')}
    >
      <GivmoWordmark className="h-[24px] w-auto text-brand-500" />
      <div className="flex flex-col gap-6">
        <h1 className="text-s24 font-w700 tracking-givmo text-text-strong">Something went wrong</h1>
        <p className="text-s14 text-text-secondary">
          We’re sorry — this page couldn’t load. Try again to continue.
        </p>
      </div>
      <Button
        appearance="saas"
        tone="primary"
        onClick={() => {
          reset();
          void router.invalidate();
        }}
        testId="app-error-retry"
      >
        Try again
      </Button>
    </main>
  );
}
